import { render, staticRenderFns } from "./GiveUserFeedbackNotice.vue?vue&type=template&id=1c217f2f&"
import script from "./GiveUserFeedbackNotice.vue?vue&type=script&lang=js&"
export * from "./GiveUserFeedbackNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports